import { encryptAES } from "../../../services/encrypt.service";

export const makeHash = async (dg_id: string, secret_key: string) => {
  const msg = {
    user_id: `${dg_id}`,
    epoch: Math.floor(Date.now() / 1000)
  };
  const msgString = JSON.stringify(msg);
  const hash = await encryptAES(msgString, secret_key);

  return hash;
};
